import { Component, Input } from '@angular/core';
import { Calldto } from '../../generated/eveportal-api/graphql';
import { SipService } from '../services/sip.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-call-history-call-card',
  templateUrl: './call-history-call-card.component.html',
  styleUrls: ['./call-history-call-card.component.css']
})
export class CallHistoryCallCardComponent {
  constructor(
    private sipService: SipService,
    private snack: MatSnackBar
  ) {}
  @Input() call!: Calldto;


  get formattedDuration(): string {
    const mins = Math.floor(this.call.duration! / 60);
    const secs = this.call.duration! % 60;
    return `${mins}m ${secs}s`;
  }

  get formattedDate(): string {
    return new Date(this.call.startTime!).toLocaleString();
  }

  async callBack() {
    // Initiate a call back to the number associated with this call
    try {
      const target = this.call.remoteParty?.number;
      if (target) {
        await this.sipService.makeCall(target);
      } else {
        console.warn('📵 No valid number to call back.');
      }
    } catch (error: any) {
      const errorMessage = "Failed to call back: " + error.message;
      this.snack.open(errorMessage, 'Dismiss');
    }
  }

   getDirectionIcon(direction: string): string {
    switch (direction) {
      case 'INCOMING_CALL':
        return 'fa-solid fa-phone-arrow-down-left'; // FontAwesome Pro
      case 'OUTGOING_CALL':
        return 'fa-solid fa-phone-arrow-up-right';
      case 'MISSED_CALL':
        return 'fa-solid fa-phone-missed';
      default:
        return 'fa-solid fa-question'; // fallback
    }
  }

  getDirectionColor(direction: any): string {
   switch (direction) {
      case 'INCOMING_CALL':
      case 'OUTGOING_CALL':     
        return 'green'; 
      case 'MISSED_CALL':
        return 'red';
      default:
        return 'inherit'; // fallback
    }
  }
}
